export const sourceTransition = {
    scale: {type: 'spring', mass: 0.3, stiffness: 200, damping: 12},
} as const;

export const destinationTransition = {
    scale: {type: 'spring', mass: 0.3, stiffness: 200, damping: 8},
} as const;
